import './libs/jquery.scrollbar.min';
import './libs/jquery-ui.min';
import './libs/jquery.ui.touch-punch.min';
import './libs/jquery.ui.sortable-animation';
import './libs/datepicker-ko';

import './asis';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SwiperCore, {Navigation, Pagination, Scrollbar, HashNavigation, A11y, Autoplay, EffectCoverflow} from 'swiper/core';

import pkg from '../package.json';

import commonUiList from "./common.ui.list";
import {
    Popup,
    PopupAlert,
    PopupTooltip,
    FormBox, DateSpinner, PopupExternal, PopupSelect
} from "./components";

import {
    scrollTo,
    setScrollbar,
    refreshUI,
    changeIOSMetaTag,
    listViewer,
    pageInnerScroll,
    toast,toastClose,
    initUI,
    editHomeDrag, editHomeDragClickEvent, setActivePosition, scrollToTarget,skeletonTabAnimation, fakePageTransition, radioPropChange, numberCountAni,numberCountAniScroll,
    checkAgree, checkAgreeDepth2, scrolllAnchor, progressPosition, progressCircle, openLyPop, fixedCtaPosition,
    fillActive, fillReset, fillRefresh, calcAnimation, asynFn, logoScrollLoop, lottieAnimation, tabSlide, checkedShow,
    tabMenuExtend,tabScrollnav, tabScrollnavLine, stampScrollList, cashbackRolling, addKeyframeEl, keyframeChaining, ddayTimer,checkCdnimage,pullToRefresh,transformCalendar,scrollAddClass,
    cardZoomEvent, chatbotLooper, AnimateProgress, Confetti,removeFixedBugClass, prdtSlideChange,swiperHeightCheck,
    decimal, fullSpinner,fixedDataItem, scrollToTop,scrClickMove,actionCtaButton,resetPopZindex,rgb2hex, rotateCardEvent, moneyMission, lottieChaining, fcreplaceTag, fcMoreCallback,
    unregisteredEvent, touchAnimation, aniDelay,popupDepth2, popupBotBtnHideOpen, puzzleEvent, puzzleEventDrag, fadeAction, onRollingNumber,onRollingNumberReset, onRollingNumberStart, lotteryEvent, imgLoadingChk,selectScrollEvent,moveItemFocusMove,inputCheckBoxWrapActive,inputRadiobuttonWrapActive,bingoSet, bingoEvent, inputCheckobj,lottieReplay,
    isA11yInitButtonRole, popupScrollTarget, scrollTransformView,textEllipsis,svgGraph,cardReverse,findingGraphReset,isA11yScrollAnimation,confirmAmount, PlusboxChart, fixedBottom, SavingsStory,gsapEvent, earnInterest, selectPopup, tooltipPopup, kvTouchEvent, scrollingAddActive, cubicCustomBez, fcCalendar,
    farm,
} from "./functions/simple.ui";
import './utils/jquery.hook';
import DrawSVGPlugin from "./libs/gsap/DrawSVGPlugin";
// import dev from './test/test.dev';
import { a11yValidateError, isA11y, isA11yAddClass, FocusTrap, _isVoiceOverCheck } from "./functions/a11y.ui";
import headerInit from "./functions/header.ui";
import {popupMixin} from "./vue/mixin";

import {appSafeAreaMargin, fnRollingTxt, planRolling, f_getStatusBarHeight} from "./asis";
import {getFormatZero} from "./utils/util";
import {mainTalkWelcome} from "./functions/main.ui"

// asis:::: main.ui.js분리건
// import {mainUI} from "./functions/main.ui";
// tobe:::: main.ui.js분리건
// import {mainUI} from "./functions/main.ui";  // 제거

// swiper lib init
SwiperCore.use([Navigation, Pagination, Scrollbar, HashNavigation, A11y, Autoplay, EffectCoverflow]);

// gsap init
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(ScrollTrigger);

window.gsap = gsap;
let frontUI = {};

const alert = new PopupAlert();
const popupTooltip = new PopupTooltip();
const version = pkg.version;
const buildDate = format(new Date());
const chatbotAni = mainTalkWelcome;

frontUI = {
    version,
    buildDate,
    isLoad: false,
    alert,
    popupTooltip,
    Popup,
    PopupSelect,
    // refresh ui
    refreshUI,
    // simple ui
    // 단독으로도 쓰이고 재사용도 되는 함수
    scrollTo,
    scrollToTarget,
    a11yValidateError,
    isA11yScrollAnimation,
    listViewer,
    changeIOSMetaTag,
    toast,
    toastClose,
    initUI,
    editHomeDrag,
    editHomeDragClickEvent,
    init,
    setActivePosition,
    skeletonTabAnimation,
    fakePageTransition,
    appSafeAreaMargin,
    numberCountAni,
    numberCountAniScroll,
    checkAgree,
    checkAgreeDepth2,
    progressPosition,
    progressCircle,
    openLyPop,
    fixedCtaPosition,
    fillReset,
    fillActive,
    fillRefresh,
    calcAnimation,
    fnRollingTxt,
    planRolling,
    asynFn,
    lottieAnimation,
    DateSpinner,
    tabSlide,
    f_getStatusBarHeight,
    chatbotAni,
    tabMenuExtend,
    tabScrollnav,
    tabScrollnavLine,
    cardZoomEvent,
    chatbotLooper,
    AnimateProgress,
    Confetti,
    removeFixedBugClass,
    prdtSlideChange,
    swiperHeightCheck,
    decimal,
    fullSpinner,
    fixedDataItem,
    scrollToTop,
    scrClickMove,
    actionCtaButton,
    resetPopZindex,
    logoScrollLoop,
    pageInnerScroll,
    rgb2hex,
    rotateCardEvent,
    unregisteredEvent,
    touchAnimation,
    aniDelay,
    popupDepth2,
    popupBotBtnHideOpen,
    isA11y,
    puzzleEvent,
    fadeAction,
    onRollingNumber,
    onRollingNumberReset,
    onRollingNumberStart,
    lotteryEvent,
    puzzleEventDrag,
    imgLoadingChk,
    selectScrollEvent,
    moveItemFocusMove,
    inputCheckBoxWrapActive,
    inputRadiobuttonWrapActive,
    bingoSet,
    bingoEvent,
    inputCheckobj,
    isA11yInitButtonRole,
    lottieReplay,
    popupScrollTarget,
    scrollTransformView,
    textEllipsis,
    svgGraph,
    FocusTrap,
    cardReverse,
    findingGraphReset,
    confirmAmount,
    stampScrollList,
    cashbackRolling,
    addKeyframeEl,
    keyframeChaining,
    ddayTimer,
    PlusboxChart,
    fixedBottom,
    SavingsStory,
    gsapEvent,
    earnInterest,
    selectPopup,
    tooltipPopup,
    checkCdnimage,
    pullToRefresh,
    kvTouchEvent,
    scrollingAddActive,
    moneyMission,
    lottieChaining,
    cubicCustomBez, //animate easing custom (2025.03.13)
    fcCalendar,
    fcreplaceTag,
    fcMoreCallback,
    farm,
    transformCalendar,
    scrollAddClass
};

window.frontUI = frontUI;



function init(){
    _isVoiceOverCheck(); //모바일 스크린리더 체크
    isA11yAddClass(); //TODO 접근성 적용 후 삭제 필요
    Popup.loadInit();
    refreshUI();
    // 페이지 초기에 init 되는 함수
    setScrollbar();

    changeIOSMetaTag();
    initUI();
    radioPropChange();
    numberCountAni();
    numberCountAniScroll()
    checkAgree();
    checkAgreeDepth2();
    scrolllAnchor();
    progressPosition();
    progressCircle()
    openLyPop();
    fixedCtaPosition();
    logoScrollLoop();
    tabSlide();
    checkedShow();
    tabMenuExtend();
    tabScrollnav();

    chatbotLooper();
    skeletonTabAnimation();
    fixedDataItem();
    unregisteredEvent();
    touchAnimation();
    aniDelay();
    popupDepth2();
    puzzleEvent();
    //fadeAction();
    onRollingNumber();
    inputCheckBoxWrapActive();
    inputRadiobuttonWrapActive();
    bingoSet();
    inputCheckobj();
    textEllipsis();
    cardReverse();
    stampScrollList();
    cashbackRolling();
    keyframeChaining();
    tooltipPopup(); // CHPFMTASK-1574
    // asis:::: main.ui.js분리건
    // mainUI();
    // tobe:::: main.ui.js분리건
    // mainUI();    // 제거
    isA11yInitButtonRole(); //role=button적용
    // scrollTransformView(); //상단 비주얼 요소 스크롤 모션 추가
    cubicCustomBez();  //animate easing custom (2025.03.13)
}

window.vueUI = {
    popupMixin
}

function format(date){
    return ''+
        `${date.getFullYear()}. ${date.getMonth()+1}. ${date.getDate()}. ` +
        `${date.getHours()<12 ? '오전':'오후'} ` +
        `${date.getHours()>12 ? date.getHours() - 12 : date.getHours()}:${getFormatZero(date.getMinutes())}:${getFormatZero(date.getSeconds())}`;
}


$(function(){
    frontUI.init();
});